// Client-side mirror of backend pricing.compute_item_share / coop_totals for the
// Bulk Buying Co-op line-item editors and pickers.

export const isCoopType = (dt) => {
  const s = String(dt || "").toLowerCase();
  return s.includes("bulk") || s.includes("co-op") || s.includes("coop") ||
    s.includes("multi") || s.includes("pack");
};

const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// The $ a partner pays for their portion of one line item.
export function itemShare(it) {
  const unit = Number(it.unit_price || 0);
  const split = String(it.split_type || "qty").toLowerCase();
  if (split === "amount") return r2(Math.max(Number(it.partner_amount || 0), 0));
  if (split === "pct") {
    const pct = Math.min(Math.max(Number(it.partner_pct || 0), 0), 100);
    return r2((unit * pct) / 100);
  }
  const total = Number(it.total_units || 0);
  const part = Number(it.partner_units || 0);
  if (total <= 0) return 0;
  return r2((unit * Math.min(part, total)) / total);
}

// Sum unit prices and partner shares across (optionally a selected subset of) items.
export function coopTotals(items, selectedIds = null) {
  let price = 0;
  let share = 0;
  for (const it of items || []) {
    if (selectedIds && !selectedIds.has(it.item_id)) continue;
    price += Number(it.unit_price || 0);
    share += it.share != null ? Number(it.share) : itemShare(it);
  }
  return { priceTotal: r2(price), shareTotal: r2(share) };
}

export const SPLIT_TYPES = [
  { value: "qty", label: "By quantity" },
  { value: "pct", label: "By percentage" },
  { value: "amount", label: "Fixed $ amount" },
];

export const emptyCoopItem = () => ({
  name: "",
  unit_price: "",
  split_type: "qty",
  total_units: "",
  partner_units: "",
  partner_pct: "",
  partner_amount: "",
  image_url: "",
});
